import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { EmailsService } from '@app-services/emails/emails.service';
import { EmailsPageStateService } from '@app-services/emails/emails-page-state.service';

@Component({
  selector: 'app-email-all-select-checkbox',
  templateUrl: './email-select-all-checkbox.component.html',
  styleUrls: ['./email-select-all-checkbox.component.scss'],
  imports: [TranslateModule, MatCheckbox],
})
export class EmailSelectAllCheckboxComponent {
  constructor(
    protected emailsService: EmailsService,
    protected emailsPageStateService: EmailsPageStateService
  ) {}
}
